import { StatusAnaliseCadastral, StatusPedido } from '../plugins/constants'
import { ListaStatusAnaliseCadastral } from '../plugins/listaStatusStyles'

export function getStatusAnaliseCadastral (status_pedido) {
  switch (status_pedido) {
    case StatusPedido.AguardandoDecisaoAnaliseCredito:
      return StatusAnaliseCadastral.EmAnalise
    case StatusPedido.AprovadoAnaliseCredito:
      return StatusAnaliseCadastral.Aprovado
    case StatusPedido.ReprovadoAnaliseCredito:
      return StatusAnaliseCadastral.Reprovado
    case StatusPedido.Rascunho:
      return StatusAnaliseCadastral.Pendente
    case StatusPedido.PendenteAnaliseCredito:
      return StatusAnaliseCadastral.PendenciaCadastral
    default:
      return StatusAnaliseCadastral.Aprovado
  }
}

export function getEstilosAnaliseCadastral (status_pedido) {
  const status = getStatusAnaliseCadastral(status_pedido)
  return ListaStatusAnaliseCadastral[status]
}
